import React from 'react';
import { Button, Modal } from '@efast_public/fjd-component-library';

interface ConfirmationModalProps {
  isConfirmationModalVisible: boolean;
  confirmationHeading: string;
  confirmationButtonLabel: string;
  abortButtonLabel: string;
  content?: React.ReactNode;
  onConfirm: () => void;
  onAbort: () => void;
}

export function ConfirmationModal({
  isConfirmationModalVisible,
  confirmationHeading,
  confirmationButtonLabel,
  abortButtonLabel,
  content,
  onConfirm,
  onAbort
}: ConfirmationModalProps) {
  return (
    <Modal open={isConfirmationModalVisible} onClose={onAbort}>
      <Modal.Header id="confirmation-modal-header" onClose={onAbort}>
        {confirmationHeading}
      </Modal.Header>
      <Modal.Content>{content}</Modal.Content>
      <Modal.Footer>
        <Button variant="ghost" onClick={onAbort}>
          {abortButtonLabel}
        </Button>
        <Button variant="primary" onClick={onConfirm}>
          {confirmationButtonLabel}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
